import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';

import {
  Button,
  Container,
  SuccessMessage,
} from '../../common/form';

import useSeriesConfigurationStore from './state-hook';
import {
  useGetSeriesConfiguration,
  saveSeriesConfiguration,
} from '../../../../services/lwadmin/series/configuration/configuration-service';

import withNameInput from '../../common/input';

const rulesOfInvestingPodcastAppleRating = 'rulesOfInvestingPodcastAppleRating';

const RulesOfInvestingPodcastAppleRating = withNameInput(
  'config',
  rulesOfInvestingPodcastAppleRating,
  useSeriesConfigurationStore,
  _.snakeCase(rulesOfInvestingPodcastAppleRating),
);

const SContainer = styled(Container)`
  padding-bottom: 40px;

  > div {
    & > div {
      width: 50%;
    }
    & > label {
      width: 50%;
    }
  }
`;

export default function Form() {
  const [, get] = useGetSeriesConfiguration();
  const [saving, setSaving] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);

  const set = useSeriesConfigurationStore(state => state.set);
  const config = useSeriesConfigurationStore(state => state.config);

  useChangeAwareEffect(({ isMount }) => {
    isMount && get().then(({ data }) => set(state => {
      state.config[rulesOfInvestingPodcastAppleRating] = _.get(data, `config.${rulesOfInvestingPodcastAppleRating}`, null);
    }));
  }, {});

  const save = e => {
    e && e.preventDefault();

    setSaving(true);

    const payload = {
      config: [{
        name: _.snakeCase(rulesOfInvestingPodcastAppleRating),
        value: config[rulesOfInvestingPodcastAppleRating],
      }],
    };

    saveSeriesConfiguration(payload).then(() => {
      setSaving(false);
      setShowSuccessMessage(true);

      set(state => {
        state.errors = {};
      });
    }).catch(error => {
      setSaving(false);
      setShowSuccessMessage(false);

      set(state => {
        state.errors = _.get(error, 'response.data', {});
      });

      setSaving(false);
    });
  };

  return (
    <SContainer>
      {showSuccessMessage && (
        <SuccessMessage>
          Configuration successfully saved
        </SuccessMessage>
      )}
      <RulesOfInvestingPodcastAppleRating />
      <Button className="btn btn-primary" onClick={save} disabled={saving}>
        {saving ? 'Saving' : 'Save'}
      </Button>
    </SContainer>
  );
}
